import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, TemplateRef } from '@angular/core';
import { NgbActiveModal, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDeleteComponent } from '../../../components/confirm-delete/confirm-delete.component';
import { Router } from '@angular/router';
import { CourseInformationFormComponent } from '../../../components/course-information-form/course-information-form.component';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { SearchComponent } from '../../../components/search/search.component';
import { LoaderComponent } from '../../../components/layout/loader/loader.component';
import { TableGuruComponent } from '../../../components/table-guru/table-guru.component';

@Component({
  selector: 'app-course-index',
  standalone: true,
  imports: [
    CommonModule,
    CourseInformationFormComponent,
    LoaderComponent,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownItem,
    NgbDropdownToggle,
    PaginationComponent,
    SearchComponent,
    TableGuruComponent
  ],
  templateUrl: './course-index.component.html',
  styleUrl: './course-index.component.scss'
})
export class CourseIndexComponent {
  items: [] = [];
  private modalService = inject(NgbModal);
  loading: boolean = false;
  currentItemId: string = '';

  editFormReference = CourseInformationFormComponent;
  reloadItems: boolean = false;

  currentPage: number = 1;
  itemsPerPage: number = 10;
  searchQuery: string = '';
  filteredItems: any = [];

  sortOrder: boolean = true; // true for ascending, false for descending
  sortField: string = '';

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {
  }

  openModal(content: TemplateRef<any>, itemId: any) {
    let self = this;

    if (itemId) {
      self.currentItemId = itemId;
    } else {
      self.currentItemId = '';
    }

    this.modalService.open(content, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title'
    }).result.then(
      (result) => {
        self.reloadItems = true;

        setTimeout(() => {
          self.reloadItems = false;
        }, 200);
      },
      (reason) => {
        self.reloadItems = true;
      },
    );
  }
}
